import {
  TopToolbar,
  ListButton,
} from 'react-admin';

const CatalogEditActions = () => (
  <TopToolbar>
    <ListButton />
  </TopToolbar>
);

export default CatalogEditActions;